import type { Slot, VNode } from 'vue';

export function hSlot(slot: Slot | undefined, otherwise?: VNode[]): VNode[] | undefined {
  return slot !== undefined ? slot() || otherwise : otherwise;
}

/**
 * Source definitely exists,
 * so it's merged with the possible slot
 */
export function hMergeSlot(slot: Slot | undefined, source: VNode[]): VNode[] {
  return slot !== undefined ? source.concat(slot()) : source;
}

export function hUniqueSlot(slot: Slot | undefined, otherwise: VNode[]): VNode[] {
  if (slot !== undefined) {
    const vnode = slot();

    if (vnode !== undefined && vnode !== null) {
      return vnode.slice();
    }
  }

  return otherwise;
}

export function hEmptyRender() {}
